import React, { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import Navlogo from "../../../assets/images/logo/NavLogo.png";
import MedidentLogo from "../../../assets/images/logo/MedidentLogo.jpeg";
import { formatDateIST } from "../Utils/UtilsFunctions";
import "./Pdf.scss";
import { BrandingContext } from "../../../BrandingProvider";
import { isTodayOrFuture } from "../../utils/utils";
import { displayPatientName } from "../../../utils/displayPatientName";
import { displayDoctorName } from "../../../utils/displayDoctorName";

const PdfHeaderDocs = ({
  hiType,
  doctorData,
  patientData,
  selectedContextDisplay,
  selectedContext,
  dateForAppointment,
  startTime,
}) => {
  const brandingData = useContext(BrandingContext);
  console.log("Branding data", brandingData);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;
  return (
    <Grid container alignContent="center">
      {/* First three grids */}
      <Grid item xs={6} sm={6} md={6} padding={2}>
        <Typography variant="h6" className="pdf-section-main-title">
          {hiType}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={6} md={6} padding={2}>
        <Grid
          container
          sx={{
            alignContent: {
              xs: "flex-start", // flex-start for extra small screens
              sm: "flex-end", // flex-end for small screens and up
            },
          }}
          flexDirection="column"
          alignItems="center"
        >
          <Grid item>
            <img
              src={`data:image/jpeg;base64,${collateralImage}`}
              className="logo-dark logo-img"
              alt="logo"
              width="100px"
              height="100px"
              style={{ paddingBottom: "3px", paddingTop: "5px" }}
            />
          </Grid>
          <Grid item>
            <Typography variant="h6" className="pdf-section-main-title">
              {collateralBrandStatement}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Last grid in a new row */}
      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            padding={2}
          // sx={{
          //   borderTop: "1px solid #ccc",
          //   borderBottom: "1px solid #ccc",
          // }}
          >
            <Typography variant="subtitle1" className="pdf-section-title">
              <b>{displayDoctorName(doctorData)}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              <b>{doctorData?.qualifications}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Doctor Registration No:{" "}
              <b>{doctorData?.registration_no ?? "NA"}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              <b>{doctorData?.department}</b>
              {doctorData?.specialization && ` - ${doctorData?.specialization}`}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} md={6} padding={2}>
            <Typography variant="subtitle1" className="pdf-section-title">
              Date:{" "}
              <b>{formatDateIST(dateForAppointment?.toISOString()).split(" ")[0]}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Time:{" "}
              <b>
                {isTodayOrFuture(dateForAppointment) ? formatDateIST(new Date().toISOString()).split(" ").slice(1).join(" ") : startTime}
              </b>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          sx={{
            borderTop: "1px solid #ccc",
            borderBottom: "1px solid #ccc",
            marginTop: "20px",
          }}
        >
          <Grid item xs={6} sm={6} md={6} padding={2}>
            <Typography variant="subtitle1" className="pdf-section-title">
              Patient's Name: <b>{displayPatientName(patientData?.name)}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Age: <b>{patientData?.age}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Gender: <b>{patientData?.gender}</b>
            </Typography>

            <Typography variant="subtitle1" className="pdf-section-title">
              ABHA Address: <b>{patientData?.abha_id}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              ABHA Number: <b>{patientData?.abha_no}</b>
            </Typography>
          </Grid>

          <Grid item xs={6} sm={6} md={6} padding={2}>
            <Typography variant="subtitle1" className="pdf-section-title">
              Patient ID: <b>{patientData?.patient_id}</b>
            </Typography>

            <Typography variant="subtitle1" className="pdf-section-title">
              Clinic Address:{" "}
              <b>
                {[
                  sessionStorage.getItem("facilityAddressLine1"),
                  sessionStorage.getItem("facilityAddressLine2"),
                  sessionStorage.getItem("facilityAddressLine3"),
                ]
                  .filter(Boolean)
                  .join(", ")}
              </b>
            </Typography>

            <Typography variant="subtitle1" className="pdf-section-title">
              Contact Number: <b>{patientData?.phone_no}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Consultation ID: <b>{selectedContext}</b>
            </Typography>
            <Typography variant="subtitle1" className="pdf-section-title">
              Visit Purpose: <b>{selectedContextDisplay}</b>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PdfHeaderDocs;
